import { useCallback, useRef } from "react";

export const useDebounce = (func, delay) => {
  const timerRef = useRef(null);

  // Keep the same function until its callback or delay changes.
  const debouncedFunction = useCallback(
    (...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        func(...args);
      }, delay);
    },
    [func, delay]
  );

  return debouncedFunction;
};
